<template>
  <div class="brand__area pb-80 pt-50">
    <div class="container">
       <div class="row">
        <div class="col-xxl-12 d-flex justify-content-start">
          <div class="section__title-wrapper text-center mb-30">
            <h2 class="section__title"> 
              <span class="yellow-bg yellow-bg-big">{{ $t('actions.our') }}
            <img src="../../assets/img/shape/yellow-bg.png" alt=""></span>{{ $t('actions.partner') }}
          </h2>
          </div>
        </div>
      </div>
      <div class="brand-active swiper-container">
        <swiper
          ref="mySwiper"
          class="swiper-wrapper align-items-center"
          :space-between="25"
          :slides-per-view="6"
          :modules="modules"
          :loop="true"
          :effect="'fade'"
          :autplay="{ delay: 3000 }"
          :breakpoints="breakpoints"
        >
          <swiper-slide v-for="brand in usefulLink" :key="brand.id">
            <a :href="brand.link" target="_blank" rel="noopener noreferrer">
            <div class="brand__item text-center" >
              <img width="50" :src="baseUrl + brand.image" class="img-fluid" alt="img" />
              <p style="font-size: 12px; line-height: 14px">{{brand?.name_uz}}</p>
            </div>
            </a>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import {mapGetters, mapActions} from 'vuex'
import BlogMixin from '../../mixins/blogMixin';

export default {
  name: "BrandArea",
  components: {
    Swiper,
    SwiperSlide,
  },
  mixins: [BlogMixin],

  data() {
    return {
      brandData: [
        {
          id: "1",
          img: "brand-1.png",
        },
        {
          id: "2",
          img: "brand-2.png",
        },
        {
          id: "3",
          img: "brand-3.png",
        },
        {
          id: "4",
          img: "brand-4.png",
        },
        {
          id: "5",
          img: "brand-5.png",
        },
        {
          id: "6",
          img: "brand-1.png",
        },
      ],
      breakpoints:{
          550:{slidesPerView: 3},
          768:{slidesPerView: 4},
          1200:{slidesPerView: 5},
      }
    };
  },
  
  created() {
    this.getUsefulLink();
  },
  computed: {
    ...mapGetters("usefulLink", ["usefulLink"])
    },
  methods: {
     ...mapActions("usefulLink", ["getUsefulLink"]),
    getImgUrl(pic) {
      return require("../../assets/img/brand/" + pic);
    },
  },
};
</script>